import { TextAreaField } from "@aws-amplify/ui-react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function ImageGen({ title, link }) {
  const [prompt, setprompt] = useState("");
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState("");
  const [imagedata, setimagedata] = useState("");
  const [preset, setPreset] = useState("");
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [genaiaccess, setgenaiaccess] = useState(false);
  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);
  const [model, setModel] = useState("dalle");
  const [openaikey, setOpenaiKey] = useState("");
  const genearateImage = async () => {
    console.log("generating");
    if (prompt.length > 0) {
      if (model == "dalle") {
        if (openaikey.length > 0) {
          seterror("");
          setloading(true);
          var data = JSON.stringify({
            api_key: openaikey,
            prompt: prompt,
          });

          var xhr = new XMLHttpRequest();

          xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
              console.log(this.responseText);
              setimagedata(this.responseText.replace(/['"]+/g, ""));
              setloading(false);
            }
          });

          xhr.open(
            "POST",
            "https://jmdz5kveu353ssocdkaepxoymi0kmduv.lambda-url.ap-south-1.on.aws/",
          );
          // xhr.setRequestHeader("Content-Type", "application/json");

          xhr.send(data);
        } else {
          seterror("please enter openai key");
        }
      } else {
        if (preset.length > 0 || model == "titan") {
          seterror("");
          setloading(true);
          var data = JSON.stringify({
            prompt: prompt,
            model: model,
            style: preset,
          });

          var xhr = new XMLHttpRequest();
          //   xhr.withCredentials = true;

          xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
              // console.log(JSON.parse(this.responseText))
              setimagedata(
                `data:image/jpeg;base64,${
                  JSON.parse(this.responseText).artifacts[0].base64
                }`,
              );
              setloading(false);
            }
          });

          xhr.open(
            "POST",
            "https://s25kzvbtg4xgk6on53rpzhy3zi0qsqyz.lambda-url.ap-south-1.on.aws/",
          );
          //   xhr.setRequestHeader("Content-Type", "application/json");

          xhr.send(data);
        } else {
          seterror("please select preset.");
        }
      }
    } else {
      seterror("please enter prompt");
    }
  };
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div className="emailsum-container">
          <div className="input-form">
            <div className="field">
              <p>Write a prompt to generate an image:</p>
              <TextAreaField
                color="white"
                id="outlined-basic"
                style={{
                  border: "1px solid white",
                  borderRadius: "0.5rem",
                  width: "100%",
                }}
                placeholder="Generate an image of polar bear playing cricket on the beach."
                value={prompt}
                onChange={(e) => {
                  setprompt(e.target.value);
                }}
                variant="outlined"
              />
            </div>

            <Button
              style={{ margin: "1rem 0" }}
              variant="contained"
              color="primary"
              onClick={genearateImage}
              startIcon={
                loading && <CircularProgress color="white" size={20} />
              }
            >
              Generate Image
            </Button>

            {/* <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel
                  style={{ color: "white" }}
                  id="demo-simple-select-label"
                >
                  Select Model
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={model}
                  style={{ borderBottom: "2px solid white" }}
                  label="Select Model"
                  onChange={(e) => setModel(e.target.value)}
                >
                  <MenuItem value={"dalle"}>DALLE</MenuItem>
                  <MenuItem value={"stability"}>Stability</MenuItem>
                </Select>
              </FormControl>
            </Box> */}
            <Box>
              <FormControl>
                <p>Select a model</p>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={model}
                  onChange={(e) => {
                    seterror("");
                    setModel(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="dalle"
                    control={<Radio />}
                    label="DALLE"
                  />
                  <FormControlLabel
                    value="stability"
                    control={<Radio />}
                    label="Stability"
                  />
                  {/* <FormControlLabel
                    value="titan"
                    control={<Radio />}
                    label="Titan"
                  /> */}
                </RadioGroup>
              </FormControl>
            </Box>
            {model == "dalle" && (
              <>
                <br />
                <p>Enter OpenAI API Key:</p>

                <TextField
                  fontColor="white"
                  id="outlined-basic"
                  style={{
                    border: "1px solid white",
                    borderRadius: "0.5rem",
                    width: "100%",
                  }}
                  value={openaikey}
                  onChange={(e) => {
                    setOpenaiKey(e.target.value);
                  }}
                  variant="outlined"
                />
              </>
            )}
            {model == "stability" && (
              <>
                <br />
                {/* <p>Select image preset:</p> */}
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel
                      style={{ color: "white" }}
                      id="demo-simple-select-label2"
                    >
                      Select preset
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label2"
                      id="demo-simple-select2"
                      value={preset}
                      style={{ borderBottom: "2px solid white" }}
                      label="Select preset"
                      onChange={(e) => setPreset(e.target.value)}
                    >
                      <MenuItem value={"3d-model"}>3d-model</MenuItem>
                      <MenuItem value={"analog-film"}>analog-film</MenuItem>
                      <MenuItem value={"anime"}>anime</MenuItem>
                      <MenuItem value={"cinematic"}>cinematic</MenuItem>
                      <MenuItem value={"comic-book"}>comic-book</MenuItem>
                      <MenuItem value={"enhance"}>enhance</MenuItem>
                      <MenuItem value={"isometric"}>isometric</MenuItem>
                      <MenuItem value={"line-art"}>line-art</MenuItem>
                      <MenuItem value={"fantasy-art"}>fantasy-art</MenuItem>
                      <MenuItem value={"low-poly"}>low-poly</MenuItem>
                      <MenuItem value={"modeling-compound"}>
                        modeling-compound
                      </MenuItem>
                      <MenuItem value={"neon-punk"}>neon-punk</MenuItem>
                      <MenuItem value={"origami"}>origami</MenuItem>
                      <MenuItem value={"photographic"}>photographic</MenuItem>
                      <MenuItem value={"pixel-art"}>pixel-art</MenuItem>
                      <MenuItem value={"tile-texture"}>tile-texture</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </>
            )}
            <br />

            {error}
          </div>
          <div className="result">
            <h4 style={{ textAlign: "center" }}>Generated Image</h4>
            <div className="result-text">
              <div style={{ position: "relative", height: "500px" }}>
                <img style={{ width: "30rem" }} src={imagedata} />
              </div>
            </div>

            {/* <Button style={{ margin: '1rem 0' }} variant="contained" color='primary'>Download Result</Button> */}
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
